/**
 * @date: 2019/9/4
 * @author: xkh
 * @desc:
 */

export const baseUrl = (str) => `${location.protocol}//api.aiizone.com/resume/${str}`;
// export const baseUrl = (str) => `http://127.0.0.1:1001/resume/${str}`;

